import script from "./RejectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectModal.vue?vue&type=script&setup=true&lang=js"

import "./RejectModal.vue?vue&type=style&index=0&id=faf78afa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faf78afa"]])

export default __exports__